import CopySubscriberButton from 'groups/components/CopySubscriberButton.jsx';
import cx from 'classnames';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import GroupActions from 'groups/actions/GroupActions';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import GroupLink from 'groups/components/GroupLink.jsx';
import GroupName from 'groups/components/GroupName.jsx';
import Groups from 'collections/Groups';
import GroupStore from 'groups/stores/GroupStore';
import Hovercard from 'components/Hovercard.jsx';
import HovercardBody from 'components/HovercardBody.jsx';
import Link from 'components/Link.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import LoadingIndicator from 'components/LoadingIndicator.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import Relationship from 'entities/Relationship';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import ScrollableArea from 'components/ScrollableArea.jsx';
import StartChatButton from 'user/components/StartChatButton.jsx';
import Text from 'components/Text.jsx';
import './styles/UserHovercard.scss';

type State = {
  groups: ?Groups;
  scrollAreaScrolled?: boolean,
};

const UserHovercard = React.createClass({
  propTypes: {
    relationship: React.PropTypes.instanceOf(Relationship),
    showSubscriptions: React.PropTypes.bool,
    neverShowStartChat: React.PropTypes.bool,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    linkStateWithStores([GroupStore]),
  ],

  getDefaultProps() {
    return {
      showSubscriptions: true,
    };
  },

  getInitialState(): State {
    return this.getStateFromStores();
  },

  componentDidMount() {
    if (!GroupStore.isLoaded()) {
      GroupActions.loadGroups();
    }
  },

  getStateFromStores(): State {
    return {
      groups: GroupStore.getOwnedGroups(),
    };
  },

  handleScrollAreaScroll() {
    const { scrollArea } = this.refs;
    this.setState({ scrollAreaScrolled: !scrollArea.isScrolledToTop() });
  },

  subText() {
    const { relationship } = this.props;
    const subscriber = relationship.getRelatedUser();

    const note = subscriber.getNote();

    if (note) {
      return (
        <Text className="UserHovercard-note" color="thunder" truncate>
          {note}
        </Text>
      );
    }

    const organizations = relationship.getCommonOrganizationsWithUser();
    return organizations.length > 0 ?
      <Text className="UserHovercard-note" color="thunder" truncate>
        {organizations.first().getName()}
      </Text> : null;
  },

  renderCopySubscriberButton() {
    return (
      <li>
        <CopySubscriberButton
          className="UserHovercard-groups-copyButton"
          relationship={this.props.relationship}
          groups={this.state.groups}
          size="small"
        />
      </li>
    );
  },

  renderOwnedGroups() {
    const { relationship } = this.props;
    let subscriptions = [];

    if (relationship && this.props.showSubscriptions) {
      const subscriber = relationship.getRelatedUser();
      subscriptions = subscriber.getSubscriptions();
    }

    if (subscriptions.length === 0) {
      return null;
    }

    return (
      <div
        className={cx('UserHovercard-groups', {
          'UserHovercard-groups-scrolled': this.state.scrollAreaScrolled,
        })}>
        <Text
          className="UserHovercard-groups-title"
          color="thunder"
          size="xxxsmall"
          weight="semibold"
          uppercase>
          Classes joined
        </Text>
        <ScrollableArea
          ref="scrollArea"
          className="UserHovercard-groups-scrollArea"
          onScroll={this.handleScrollAreaScroll}
          showShadows>
          <ul className="UserHovercard-groups-list">
            {subscriptions.map(subscription => {
              const group = subscription.getGroup();

              return (
                <li key={subscription.getGroupId()}>
                  <GroupLink
                    className="UserHovercard-groups-list-item"
                    group={group}
                    color="pitch">
                    <FlexibleBlock flex="right">
                      <GroupAvatar
                        className="UserHovercard-groups-list-item-avatar"
                        group={group}
                      />
                      <Text truncate>
                        <GroupName group={group} />
                      </Text>
                    </FlexibleBlock>
                  </GroupLink>
                </li>
              );
            })}
            {this.renderCopySubscriberButton()}
          </ul>
        </ScrollableArea>
      </div>
    );
  },

  renderStartChat() {
    if (this.props.neverShowStartChat) {
      return null;
    }

    const { relationship } = this.props;
    if (!relationship.isEligibleForChat()) {
      return null;
    }

    return (
      <StartChatButton
        className="UserHovercard-startChatButton"
        subscriber={relationship.getRelatedUser()}
        full
      />
    );
  },

  renderBody() {
    const { relationship } = this.props;
    const subscriber = relationship.getRelatedUser();

    let name = (
      <h6 className="UserHovercard-name">
        <Text truncate>{subscriber.getName()}</Text>
      </h6>
    );

    // Only link to RelationshipModal if they have a relationship
    if (relationship.isEligibleForChat() || (relationship.getSubscriptionsToMe().length > 0)) {
      name = (
        <ModalTrigger modal={<RelationshipModal userId={subscriber.id} />}>
          <Link color="pitch">
            {name}
          </Link>
        </ModalTrigger>
      );
    }

    return (
      <div>
        {name}
        {this.subText()}
        {this.renderOwnedGroups()}
        {this.renderStartChat()}
      </div>
    );
  },

  render() {
    const body = this.props.relationship ?
      this.renderBody() :
      <LoadingIndicator />;

    return (
      <Hovercard
        {...this.props}
        className={cx('UserHovercard', this.props.className)}>
        <HovercardBody>
          {body}
        </HovercardBody>
      </Hovercard>
    );
  },
});

export default UserHovercard;



// WEBPACK FOOTER //
// ./src/users/components/UserHovercard.jsx